module.exports = __webpack_public_path__ + "img/A1 (6).a8ebf0a3.jpg";